import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ContentItemOpinion } from "~/components/content/content-item-render/variants/opinion";
import type { topicContentListOpinion$key } from "~/queries/__generated__/topicContentListOpinion.graphql";

import { CardContainer, MainContainer } from "./styles";

type Props = {
  className?: string;
  reference: topicContentListOpinion$key;
};

export const TopicContentListTopicOpinion: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const data = useFragment(
    graphql`
      fragment topicContentListOpinion on Topic
      @argumentDefinitions(
        applicationIds: { type: "[String]", defaultValue: [] }
        opinionAndColumnArticleTypeIds: { type: "[String]", defaultValue: [] }
        scmpPlusPaywallTypeIds: { type: "[String]", defaultValue: [] }
      ) {
        latestOpinions: contents(
          first: 10
          filter: {
            applicationIds: $applicationIds
            articleTypeIds: $opinionAndColumnArticleTypeIds
          }
          exclude: { paywallTypeIds: $scmpPlusPaywallTypeIds }
          orderBy: { field: PUBLISHED_DATE, direction: DESC }
        ) {
          edges {
            node {
              __typename
              entityId
              ...opinionContentItemContent
            }
          }
        }
        entityId
      }
    `,
    reference_,
  );

  if (!data.latestOpinions?.edges.length) return null;

  return (
    <MainContainer className={className}>
      {data.latestOpinions?.edges.map(({ node }) => (
        <CardContainer key={node.entityId}>
          <ContentItemOpinion reference={node} />
        </CardContainer>
      ))}
    </MainContainer>
  );
};

TopicContentListTopicOpinion.displayName = "TopicContentListTopicOpinion";
